import * as angular from 'angular';

"use strict";

angular.module('ManageInactivityModule', []);

export default 'ManageInactivityModule';